import { render, staticRenderFns } from "./SimilarContentToast.vue?vue&type=template&id=58329da2&scoped=true&"
import script from "./SimilarContentToast.vue?vue&type=script&lang=js&"
export * from "./SimilarContentToast.vue?vue&type=script&lang=js&"
import style0 from "./SimilarContentToast.vue?vue&type=style&index=0&id=58329da2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58329da2",
  null
  
)

export default component.exports